import xhr from '../utils/fetch';

const getTutors = async () => {
  return await xhr({
    url: `/tutors`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getFilteredTutors = async (filters: any) => {
  return await xhr({
    url: `/tutors-page`,
    method: 'POST',
    body: filters
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getRecentlyViewedTutors = async (userId: string) => {
  return await xhr({
    url: `/${userId}/recent-tutors`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const addRecentlyViewedTutor = async ({ userId, tutorId }: { userId: string; tutorId: string }) => {
  return await xhr({
    url: `/${userId}/recent-tutors`,
    method: 'POST',
    body: { userId, tutorId }
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getTutorById = async (tutorId: string) => {
  return await xhr({
    url: `/tutors/${tutorId}`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const tutorsApi = {
  getTutors,
  getFilteredTutors,
  getRecentlyViewedTutors,
  addRecentlyViewedTutor,
  getTutorById
};

export default tutorsApi;
